import React from 'react';

const TabsPanel = ({ tabs, activeTab }) => {
  return (
    <div>
      {tabs.map((tab, index) => (
        <div
          key={index}
          style={{
            display: activeTab === index ? 'block' : 'none',
            visibility: activeTab === index ? 'visible' : 'hidden',
            height: activeTab === index ? 'auto' : 0,
            overflow: activeTab === index ? 'visible' : 'hidden'
          }}
        >
          {tab.component}
        </div>
      ))}
    </div>
  );
};

export default TabsPanel;